<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('customer_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-account-cash</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-customer-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('qualitycheck.customer.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>
              <td><strong>{{ $t('global.id') }}</strong></td>
              <td>
                                    {{ item['id'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('qualitycheck.distributor.distributor') }}</strong></td>
              <td>
                                    <span v-if="item['distributor']">{{ item['distributor'].name }}</span>
              </td>
              <td><strong>{{ $t('ticket.tags') }}</strong></td>
              <td >
                <div id="tags">
                <v-chip v-for="tag in item['tags']" :key="tag.id"
                  class="ma-1 font-weight-bold"

                    color="secondary"
                  >
                    {{ tag.name }}
                  </v-chip>
                </div>
              </td>
              

            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.customer.description') }}</strong></td>
              <td>
                    {{ item['description'] }}
              </td>
              <td><strong>{{ $t('qualitycheck.customer.comment') }}</strong></td>
              <td>
                                    {{ item['comment'] }}
              </td>

            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <ContactListCustomer
              ref="ContactListCustomer"
              :customerParent="item"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <ContractListCustomer
              ref="ContractListCustomer"
              :customerParent="item"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <ProductListCustomer
              ref="ProductListCustomer"
              :customerParent="item"
            />
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <TicketListCustomer
              ref="TicketListCustomer"
              :customerParent="item"
            />
          </v-col>
        </v-row>
      </v-container>


    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import ProductListCustomer from '../product/ListCustomer';
import TicketListCustomer from '../ticket/ListCustomer';
import ContactListCustomer from '../contact/ListCustomer';
import ContractListCustomer from '../contract/ListCustomer';

const servicePrefix = 'Customer';

export default {
  name: 'CustomerShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ProductListCustomer,
      TicketListCustomer,
      ContactListCustomer,
      ContractListCustomer
  },
  data() {
    return {

    };
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('customer', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('customer', ['find']),

  },
  methods: {
    ...mapActions('customer', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),

  }
};
</script>
